import BreadCrumbWrapper from 'components/global/BreadCrumbs/BreadCrumbs';
import CapitalCallPortionList from 'components/global/CapitalCallPortionList';

const VCCapitalCallPortionsList = () => (
  <BreadCrumbWrapper labels={['Transactions']}>
    <CapitalCallPortionList />
  </BreadCrumbWrapper>
);
export default VCCapitalCallPortionsList;
